import CardItem from 'txp-data/lib/schema/viewSchema/CardItem';
import isEntityTypeEditable from './isEntityTypeEditable';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import {
    isEntityContainsLodging,
    isServiceReservationEntity,
} from 'owa-txp/lib/utils/view/entityCheckHelpers';

export default function shouldShowEditButton(
    txpConfiguration: TxpConfiguration,
    cardItem?: CardItem,
    entityNamesMap?: number
): boolean {
    let entityTypeEditable: boolean;
    let isEditableCardEnabled: boolean = txpConfiguration && txpConfiguration.isEditableCardEnabled;

    if (cardItem) {
        entityTypeEditable = isEntityTypeEditable(cardItem.entityType);
        return !!(isEditableCardEnabled && entityTypeEditable && cardItem.inferenceId);
    } else if (entityNamesMap) {
        entityTypeEditable =
            isEntityContainsLodging(entityNamesMap) || isServiceReservationEntity(entityNamesMap);
        return !!(isEditableCardEnabled && entityTypeEditable);
    }
    return false;
}
